import { TAddress, ValidatedState } from "../../../../common/types"
import { TResourceValue } from "../../../../services/valuesManager/valuesManager"

export const orderItemValidationErrorFieldName = "orderItemValidationError";
export const orderItemValidationErrorFieldLabel = "Referral Validation";
export const DEFAULT_ORDER_ITEM_REJECTION_REASON = "This referral was rejected by a validation rule.";

export interface ILanguageState extends ValidatedState {
    appointmentType?: TResourceValue,
    appointmentDate?: Date,
    appointmentDateString?: string,
    appointmentTime?: Date;
    appointmentTimeString?: string;
    languageCertification?: TResourceValue,
    language?: TResourceValue,
    phone: string,
    doctorName: string,
    address?: TAddress,
    additionalInstructions: string,
    vendorNotes?: string;
    isRush: boolean,
    orderItemValidationError?: string,
}

export const defaultLanguageState: ILanguageState = {
    phone: "",
    doctorName: "",
    additionalInstructions: "",
    isRush: false,
    errors: [],
}